// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.category-container {
  padding: 20px;
  background: #020617;
  min-height: 100vh;
  color: #fff;
}

/* Header */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* Search */
.search-bar {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #334155;
  background: #020617;
  color: #fff;
  width: 250px;
}

/* Add Button */
.add-btn {
  background: #facc15;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.add-btn:hover {
  background: #eab308;
}

/* Table Action Icons */
.action-icons {
  display: flex;
  gap: 8px;
}

/* ICON BUTTON FIX 🔥 */
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e293b;
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
}

/* ICON COLOR FIX */
.icon-btn svg {
  color: #fff !important;
  width: 16px;
  height: 16px;
}

/* Hover */
.icon-btn:hover {
  background: #334155;
}

/* Delete Button */
.icon-btn.delete {
  background: #7f1d1d;
}

.icon-btn.delete:hover {
  background: #991b1b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-pill.active {
  background: #dcfce7;
  color: green;
}

.status-pill.inactive {
  background: #fee2e2;
  color: red;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 12px;
}

.pagination button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background: #1e293b;
  color: #fff;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal Box */
.modal-content {
  background: #020617;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  color: #fff;
  position: relative;
}

/* Modal Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* CLOSE BUTTON FIX 🔥 */
.close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
}

/* CLOSE ICON FIX */
.close-btn svg {
  color: #fff !important;
}

/* Inputs */
.modal-content input,
.modal-content select {
  width: 100%;
  margin-top: 10px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #334155;
  background: #020617;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Bank Master/bankList.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* Container */\n.category-container {\n  padding: 20px;\n  background: #020617;\n  min-height: 100vh;\n  color: #fff;\n}\n\n/* Header */\n.header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n/* Search */\n.search-bar {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #fff;\n  width: 250px;\n}\n\n/* Add Button */\n.add-btn {\n  background: #facc15;\n  color: #000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.add-btn:hover {\n  background: #eab308;\n}\n\n/* Table Action Icons */\n.action-icons {\n  display: flex;\n  gap: 8px;\n}\n\n/* ICON BUTTON FIX 🔥 */\n.icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1e293b;\n  border: none;\n  padding: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* ICON COLOR FIX */\n.icon-btn svg {\n  color: #fff !important;\n  width: 16px;\n  height: 16px;\n}\n\n/* Hover */\n.icon-btn:hover {\n  background: #334155;\n}\n\n/* Delete Button */\n.icon-btn.delete {\n  background: #7f1d1d;\n}\n\n.icon-btn.delete:hover {\n  background: #991b1b;\n}\n\n/* Status */\n.status-pill {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-pill.active {\n  background: #dcfce7;\n  color: green;\n}\n\n.status-pill.inactive {\n  background: #fee2e2;\n  color: red;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  gap: 12px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  background: #1e293b;\n  color: #fff;\n  cursor: pointer;\n}\n\n.pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Modal Box */\n.modal-content {\n  background: #020617;\n  padding: 20px;\n  border-radius: 10px;\n  width: 400px;\n  color: #fff;\n  position: relative;\n}\n\n/* Modal Header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* CLOSE BUTTON FIX 🔥 */\n.close-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n/* CLOSE ICON FIX */\n.close-btn svg {\n  color: #fff !important;\n}\n\n/* Inputs */\n.modal-content input,\n.modal-content select {\n  width: 100%;\n  margin-top: 10px;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
